
/**
 * Search Template Options Search Filter
 */
jQuery( document ).ready( function() {
	jQuery( '#post-type-option li span' ).on( 'click', function() {
		jQuery( '#post-type-option li span' ).removeClass( 'active' );
		jQuery( this ).addClass( 'active' );
	} );

	jQuery( '#post-year-option li span' ).on( 'click', function() {
		jQuery( '#post-year-option li span' ).removeClass( 'active' );
		jQuery( this ).addClass( 'active' );
	} );

	jQuery( '#post-type-option li, #post-year-option li' ).on(
		'click',
		function() {
			let postType = '';
			let year = '';
			jQuery( '#post-type-option li' ).each( function() {
				const item = jQuery( this ).find( 'span' );
				if ( jQuery( item ).hasClass( 'active' ) ) {
					postType = item.data( 'post-type' );
				}
			} );
			jQuery( '#post-year-option li' ).each( function() {
				const item = jQuery( this ).find( 'span' );
				if ( jQuery( item ).hasClass( 'active' ) ) {
					year = item.data( 'year' );
				}
			} );

			jQuery.ajax( {
				url: localVars.ajax_url, // AJAX handler URL (defined by WordPress)
				type: 'POST',
				data: {
					action: 'select_filter',
					postType,
					year,
				},
				success(response) {
					if (response) {
						jQuery(".search-article-container").empty();
						jQuery(".search-article-container").append(response);
					} else {
						jQuery(".search-article-container").empty();
						jQuery(".search-article-container").append(response);
					}
				},
			} );
		}
	);
} );
/**
 * Search Template Options Search Filter
 */

/**
 * Sorting a to z and z to a order
 */
jQuery( document ).ready( function() {
	jQuery( '#sort-a-to-z' ).on( 'click', function() {
		sortPosts( 'asc' );
	} );

	jQuery( '#sort-z-to-a' ).on( 'click', function() {
		sortPosts( 'desc' );
	} );

	function sortPosts( order ) {
		const posts = jQuery( '.filter-posts__items article' );
		posts.sort( function( a, b ) {
			const titleA = jQuery( a ).find( 'h2' ).data( 'title' ).toUpperCase();
			const titleB = jQuery( b ).find( 'h2' ).data( 'title' ).toUpperCase();
			if ( order === 'asc' ) {
				if ( titleA < titleB ) {
					return -1;
				}
				if ( titleA > titleB ) {
					return 1;
				}
			} else {
				if ( titleA > titleB ) {
					return -1;
				}
				if ( titleA < titleB ) {
					return 1;
				}
			}
			return 0;
		} );

		jQuery( '.filter-posts__items' ).html( posts );
	}
} );

/**
 * Sorting a to z and z to a order
 */
